/**
 * Onboarding shell — the three-row grid (header / two-column / footer) that
 * every onboarding screen sits in.
 *
 * Single page scroll: the shell is `min-height: 100dvh`, both columns share
 * the browser scrollbar. Below 960px the brand column hides and the form
 * expands. All of that is done in `onboarding.css` because the rules are
 * easier to read as proper grid/media-query CSS than a hundred Tailwind
 * arbitrary values.
 *
 * Consumer must import `./onboarding.css` once at the feature root.
 *
 * @see prototype/styles/auth.css — mirrored
 */
import * as React from "react";
import { cn } from "@flint/ui";

export interface OnboardingShellProps extends React.HTMLAttributes<HTMLElement> {
  header: React.ReactNode;
  brand: React.ReactNode;
  footer?: React.ReactNode;
}

export function OnboardingShell({
  header,
  brand,
  footer,
  children,
  className,
  ...props
}: OnboardingShellProps) {
  return (
    <main className={cn("lo-shell", className)} {...props}>
      {header}
      <div className="lo-grid">
        <aside className="lo-brand-col">{brand}</aside>
        <section className="lo-form-col">
          <div className="w-full max-w-[480px] flex flex-col gap-7">{children}</div>
        </section>
      </div>
      {footer ? <footer className="lo-footer">{footer}</footer> : null}
    </main>
  );
}
